import envBaseUrl from 'src/components/pipelines/utils/env-base-url';
import {
  capturePipelinesExceptionWithTags,
  createErrorMessage,
} from 'src/components/pipelines/utils/sentry';
import {
  publishTrackEvent,
  type TrackEvent,
} from 'src/utils/analytics/publish';
import authRequest, { jsonHeaders } from 'src/utils/fetch';

export const getAiUrl = (repositoryFullSlug: string): string =>
  `${envBaseUrl('/!api/internal')}/repositories/${repositoryFullSlug}/ai`;

export const getAiRequestHeaders = (
  prompt: string,
  context: string
): RequestInit => ({
  method: 'POST',
  headers: jsonHeaders,
  body: JSON.stringify({
    prompt,
    context,
  }),
});

export async function fetchData(
  url: string,
  options: RequestInit = {},
  sentryErrorSegment: string,
  responseType: 'json' | 'text' = 'json'
): Promise<any> {
  try {
    const req = authRequest(url, options);
    const resp = await fetch(req);

    if (!resp.ok) {
      throw new Error(await createErrorMessage(resp));
    }

    const data =
      responseType === 'json' ? await resp.json() : await resp.text();
    return data;
  } catch (e) {
    capturePipelinesExceptionWithTags(e, {
      segment: sentryErrorSegment,
    });
    throw e;
  }
}

export const customAnalyticsFire = (aiEvent: any, repositoryUuid: string) => {
  const event = {
    ...aiEvent,
    attributes: {
      ...aiEvent.attributes,
      repositoryId: repositoryUuid?.replace(/{|}/g, ''),
    },
  };
  publishTrackEvent(event as TrackEvent);
};
